export const environment = {
  production: true,
  serverUrl: 'https://keekuedgeservice.azurewebsites.net/',
  clientUrl: 'https://citizex.ai/',
  version: '1.0',
  Date: '2024',
};
